/**
 * Life フロアレイアウト定数
 *
 * 詳細設計書 §2.2 に基づく静的定義。
 * API から返されない使用不可席（F-01〜F-04）もここで管理する。
 */

/** メイングリッドの行番号 */
export const ROWS = [1, 2, 3, 4, 5];

/** メイングリッドの列 */
export const COLS = ['A', 'B', 'C', 'D'];

/**
 * メイングリッド座席一覧（5行 × 4列 = 20席）
 * 例: ['A-01', 'B-01', ..., 'D-05']
 */
export const GRID_SEATS = ROWS.flatMap((row) =>
  COLS.map((col) => `${col}-${String(row).padStart(2, '0')}`)
);

/**
 * 使用不可席（API からは返されない・フロントエンド静的定義）
 * 絶対座標でグリッド下段左側（A/B 列側）に配置する。
 */
export const UNAVAILABLE_SEATS = [
  { id: 'F-01', style: { position: 'absolute', left: 0,  top: 0  } },
  { id: 'F-02', style: { position: 'absolute', left: 72, top: 0  } },
  { id: 'F-03', style: { position: 'absolute', left: 0,  top: 62 } },
  { id: 'F-04', style: { position: 'absolute', left: 72, top: 62 } },
];

/**
 * E 席（円卓エリア）の座標
 * 絶対座標でグリッド下段右側（C/D 列側）に配置する。
 */
export const E_SEATS = [
  { id: 'E-01', style: { position: 'absolute', left: 144, top: 0  } },
  { id: 'E-02', style: { position: 'absolute', left: 216, top: 0  } },
  { id: 'E-03', style: { position: 'absolute', left: 180, top: 62 } },
];

/** グリッド幅（px）: 4列 × 64px + 3gap × 8px */
export const GRID_WIDTH = 280;
